/* src/app/candidate/candidate-slider/document-preview/document-preview.component.scss */
/*# sourceMappingURL=document-preview.component-FHPAIGYC.css.map */
